<template>
  <TemplateRegistro :titulo="titulo" :texto="texto" @intro="submit()">
    <label for="uname1"><strong>Contraseña</strong></label>
    <input
      id="uname1"
      v-model.trim="clave1"
      type="password"
      placeholder="Escribe una contraseña"
      required
      nselectstart="return false"
      onpaste="return false;"
      onCopy="return false"
      onCut="return false"
      onDrag="return false"
      onDrop="return false"
      autocomplete="off"
    />

    <label for="uname2"><strong>Repite la contraseña</strong></label>
    <input
      id="uname2"
      v-model.trim="clave2"
      type="password"
      placeholder="Repite la contraseña"
      required
      nselectstart="return false"
      onpaste="return false;"
      onCopy="return false"
      onCut="return false"
      onDrag="return false"
      onDrop="return false"
      autocomplete="off"
    />

    <PanelMensajes :mensaje="error" clase="error" />

    <button type="submit" class="pure-button ripple" @click.prevent="submit()">
      <strong>Continuar</strong>
    </button>
  </TemplateRegistro>
</template>

<script>
export default {
  data() {
    return {
      clave1: "",
      clave2: "",
      error: "",
      titulo: "Escribe una contraseña",
      texto: "Debe tener al menos 8 caracteres alfanuméricos",
    };
  },

  methods: {
    submit: async function () {
      let result = await this.$store.dispatch("actualizarPassword", {
        clave1: this.clave1,
        clave2: this.clave2,
      });

      if (result.codigo != 0) {
        this.error = result.mensaje;
        return;
      }

      result = await this.$store.dispatch("loginRegistro");
      if (result.codigo != 0) {
        this.error = result.mensaje;
        return;
      }

      await this.$store.dispatch("getPortfolio");
      this.$store.dispatch("getUrlClubMMT");

      if (this.$store.state.registroInfo.email != null)
        this.$router.replace({ name: "validEmail" });
      else this.$router.replace({ name: "email" });
    },
  },
};
</script>

<style lang="scss" scoped></style>
